import Axios from "axios";
import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    NavLink,
    useParams,
    useRouteMatch,
    useHistory,
    Redirect,
} from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import hoistStatics from "hoist-non-react-statics";
import Func from "../../functions";
import Loading from "../../layouts/Loading";
import Env from "../../env";

class EnterPayerInfo extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount = async () => {
        this.props.i18n.changeLanguage(this.props.lngName);
    };

    setLoading = (v) => {
        this.setState({ isLoading: v });
    };

    render() {
        let showPayerNameStyle = this.props.styles.displayNormal;

        return (
            <div>
                <div className="form-group row" style={showPayerNameStyle}>
                    <label className="col-sm-12 col-form-label text-sm">
                        {this.props.t(
                            "Cashier." + this.props.data.payerInfoType
                        )}
                    </label>
                    <div
                        className="col-sm-12 input-group input-group-sm"
                        style={this.props.styles.rowMarginBottom}
                    >
                        <input
                            id="payerName"
                            name="payerName"
                            className="form-control form-control-sm"
                            style={this.props.styles.inputReadOnlyStyle}
                            value={this.props.payerName}
                            onChange={(e) => this.props.changePayerName(e)}
                        />
                        <div className="input-group-append">
                            <button
                                type="button"
                                className="btn btn-sm btn-info btn-flat"
                                style={this.props.styles.inputEndRadius}
                                onClick={() => this.props.enterPayerName()}
                            >
                                {this.props.t("Cashier.Submit")}
                            </button>
                        </div>
                        <div className="input-group text-danger text-xs">
                            {this.props.t(
                                "Cashier." + this.props.data.payerInfoDesc
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default hoistStatics(withTranslation()(EnterPayerInfo), EnterPayerInfo);
